import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RolPlataforma } from '../../core/models/novedades.models';
import { RoleContextService } from '../../core/services/role-context.service';
import { SidebarMenu } from '../../shared/sidebar-menu/sidebar-menu';
import { PostulacionesPanel } from './components/postulaciones-panel/postulaciones-panel';
import { InicioConcursosPanel } from '../inicio/components/inicio-concursos-panel/inicio-concursos-panel';
import { AccessibilityToolbar } from '../../shared/components/accessibility-toolbar/accessibility-toolbar';
import { BreadcrumbItem, Breadcrumbs } from '../../shared/components/breadcrumbs/breadcrumbs';
import { HeaderNotificationBell } from '../../shared/components/header-notification-bell/header-notification-bell';
import { UserSessionSummary } from '../../shared/components/user-session-summary/user-session-summary';
import { routeForRole } from '../../core/utils/roles.util';

@Component({
  selector: 'app-postulaciones',
  imports: [
    CommonModule,
    SidebarMenu,
    PostulacionesPanel,
    InicioConcursosPanel,
    HeaderNotificationBell,
    AccessibilityToolbar,
    Breadcrumbs,
    UserSessionSummary,
  ],
  templateUrl: './postulaciones.html',
  styleUrl: './postulaciones.css',
})
export class Postulaciones {
  readonly breadcrumbs: BreadcrumbItem[] = [{ label: 'Inicio', link: '/principal' }, { label: 'Postulaciones' }];
  rol: RolPlataforma = 'analista';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly roleContext: RoleContextService
  ) {
    this.route.queryParamMap.subscribe((params) => {
      this.rol = this.roleContext.resolveRole(params, this.rol);
      this.redirigirSiNoAplica();
    });
  }

  get esRolPostulante(): boolean {
    return this.rol === 'postulante';
  }

  get puedeAccederPostulaciones(): boolean {
    return this.rol === 'postulante' || this.rol === 'urc' || this.rol === 'analista';
  }

  private redirigirSiNoAplica(): void {
    if (this.puedeAccederPostulaciones) return;

    this.router.navigate([routeForRole(this.rol)], {
      queryParams: { role: this.rol },
      replaceUrl: true,
    });
  }
}
